import { defineComponent as _defineComponent } from 'vue'
import { useAuth } from "@/logics/useAuth"
import useNotification from "@/logics/useNotification"
import router from "@/router"
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  name: 'LogoutPage',
  setup(__props, { expose }) {
  expose();


const { logout } = useAuth();
const notification = useNotification();

onMounted(()=> {
  logout();
  notification.showMessage('Đã đăng xuất thành công');
  router.push({'name': 'login'})
});


const __returned__ = { logout, notification }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})